import { Helmet } from '@dr.pogodin/react-helmet';

/** Sets the browser tab title as "<title> · Formshive" while mounted. */
export function DocumentTitle({ title }: { title: string }) {
  return (
    <Helmet>
      <title>{`${title} · Formshive`}</title>
    </Helmet>
  );
}
